<template>
  <div>
    <b-notification :closable="false">
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-1') }}
      <ul style="list-style-type: square; margin-left: 25px">
        <li>
          {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-li-1') }}
        </li>
        <li>
          {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-li-2') }}
        </li>
        <li>
          {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-li-3') }}
        </li>
        <li>
          {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-li-4') }}
        </li>
        <li>
          {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-li-5') }}
        </li>
      </ul>
    </b-notification>
    <b-notification :closable="false">
      <em>{{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-2') }}</em>
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-3') }}
    </b-notification>
    <b-notification :closable="false">
      <em>{{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-4') }}</em>
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-5') }}<br />
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-6') }}<br />
    </b-notification>
    <b-notification :closable="false">
      <em>{{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-7') }}</em>
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-8') }}
    </b-notification>
    <b-notification :closable="false">
      <em>{{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-9') }}</em>
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-10') }}
    </b-notification>
    <b-notification :closable="false">
      <em>{{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-11') }}</em>
      {{ $t('compCarbonFormsBuildingsHelpCalculatingMethod.text-12') }}
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
